/* eslint-disable import/prefer-default-export */
import axios from 'axios'
// eslint-disable-next-line import/no-extraneous-dependencies
// import MockAdapter from 'axios-mock-adapter'
import Cookies from 'js-cookie'
import {addDays, formatISO} from 'date-fns'
import AxiosInterceptor from '../hooks/AxiosInterceptorHook'
import {apiURLs, AddPDPCookie, } from './Utility'

import { getCsrfToken as getStoredCsrfToken } from './csrfToken'

const csrfCookieNames = ['XSRF-TOKEN', 'CSRF-TOKEN', 'X-CSRF-TOKEN']

const getCsrfToken = () => {
  const storedToken = getStoredCsrfToken()
  if(storedToken) {
    return storedToken
  }
  for(let i = 0; i < csrfCookieNames.length; i += 1) {
    const token = Cookies.get(csrfCookieNames[i])
    if(token) {
      return token
    }
  }
  return null
}

const withCsrfHeader = (request = {}) => {
  const method = (request.method || 'GET').toUpperCase()
  if(!['POST', 'PUT', 'PATCH', 'DELETE'].includes(method)) {
    return request
  }

  const csrfToken = getCsrfToken()
  if(!csrfToken) {
    return Promise.reject(new Error('CSRF token not found. Unable to send request.'))
  }

  return {
    ...request,
    headers: {
      ...(request.headers || {}),
      'X-CSRF-Token': csrfToken,
      'X-XSRF-TOKEN': csrfToken
    }
  }
}

/**
 * Custome axios instance for usermanager api
 * @param {string} companyId
 * @param {string} iPlanetDirectoryProCookie
 * @param {string} bearerToken
 */
// defaults for bearer token and planetprocookie are set in loginHook
// after call to logLogin
const createTransactionMiddlewareAxiosInstance = () => {
  const axiosInstance = axios.create({
    baseURL: `${apiURLs.atmProjectBaseUrl}`,
    headers: {
      'Content-Type': 'application/json'
    },
    xsrfCookieName: 'XSRF-TOKEN',
    xsrfHeaderName: 'X-XSRF-TOKEN',
    withCredentials: true

  })

  AddPDPCookie(axiosInstance)
  axiosInstance.interceptors.request.use(withCsrfHeader)

  const interceptor = AxiosInterceptor(axiosInstance)

  return {axiosInstance, interceptor}
}

const AtmProjectsAxiosInstance = createTransactionMiddlewareAxiosInstance()



export default {

  getProjects: (fromDateTime, toDateTime) => {

    // eslint-disable-next-line no-underscore-dangle
    // if (window._env.ATMPROJECTS_DATA) {

    //   // This sets the mock adapter on the default instance
    //   const mock = new MockAdapter(axios);

    //   // Mock any GET request to /users
    //   // arguments for reply are (status, data, headers)
    //   mock.onGet("/").reply(200,
    //     // eslint-disable-next-line no-underscore-dangle
    //     window._env.ATMPROJECTS_DATA
    //   );

    //   return axios.get("/")
    // }

    const adjustedFromDateTime = fromDateTime
      ? new Date(fromDateTime.setHours(0, 0, 0, 0))
      : addDays(new Date(new Date(Date.now()).setHours(0, 0, 0, 0)), -1080);
    const adjustedToDateTime = toDateTime
      ? new Date(toDateTime.setHours(23, 59, 59, 997))
      : addDays(new Date(new Date(Date.now()).setHours(23, 59, 59, 997)), 180);
    const formattedFromDateTime = formatISO(adjustedFromDateTime, { format: "extended", representation: 'complete' }); // "yyyy-MM-ddTHH:mm:ss.fffzzz"
    const formattedToDateTime = formatISO(adjustedToDateTime, { format: "extended", representation: 'complete' }); // "yyyy-MM-ddTHH:mm:ss.fffzzz"
    // const params = {fromDateTime, toDateTime}

    return AtmProjectsAxiosInstance.axiosInstance({
      method: 'GET',
      // params,
      url: `/${formattedFromDateTime}/${formattedToDateTime}`
    })

  },
  convert: (atmProjects) => {
    const url = '/convert'
    return AtmProjectsAxiosInstance.axiosInstance({
      url,
      method: 'POST',
      data:
        {atmProjects}
    }
    )
  },
  setJwtToken: jwtToken => {
    AtmProjectsAxiosInstance.axiosInstance.defaults.headers.common.Authorization = `Bearer ${jwtToken}`
  },

  setRequestInterceptor: (interceptor) => {
    AtmProjectsAxiosInstance.interceptor.setRequestInterceptor(interceptor)
  },
  setResponseInterceptor: (interceptor) => {
    AtmProjectsAxiosInstance.interceptor.setResponseInterceptor(interceptor)
  },

  ready: () => {
    return (AtmProjectsAxiosInstance.axiosInstance
      && AtmProjectsAxiosInstance.axiosInstance.defaults
      && AtmProjectsAxiosInstance.axiosInstance.defaults.headers
      && AtmProjectsAxiosInstance.axiosInstance.defaults.headers.common
      && AtmProjectsAxiosInstance.axiosInstance.defaults.headers.common.Authorization
      && true)
  }
}

